import AuthActions from '../actions/authActions';
import CourseActions from '../actions/courseActions';

function authReducer(state = {
    user: null,
    iserror: false,
    isLoading: false,
    updateError: false
}, action) {

    switch (action.type) {
        case AuthActions.signin:
            return {
                ...state,
                user: {...action.data.user,pc_access_token:action.data.pc_access_token},
            };
            break;

        case AuthActions.signinFailed:
            return {
                ...state,
                iserror : action.data.error,
                isLoading: false
            };
            break;

        // case AuthActions.signup:
        //     return {
        //         ...state,
        //         user: action.data,
        //     };
        //     break;

        case AuthActions.logout:
            return {
                ...state,
                user: null,
            };
            break;

        case AuthActions.fbSignin:
            return {
                ...state,
                user: {...action.data.user,pc_access_token:action.data.pc_access_token},
                isLoading : false
            };
            break;

        case AuthActions.fbSigninFailed:
            return {
                ...state,
                iserror: true,
                isLoading: false
            };
            break;

        case AuthActions.clearState:
            return {
                ...state,
                iserror: false,
                isLoading: true,
                updateError: false
            };
            break;

        case AuthActions.fbLogout:
            return {
                ...state,
                user: null,
            };
            break;

        case AuthActions.updateProfile:
            return {
                ...state,
                user: {...state.user,panacloudid:action.data.data},
                isLoading : false
            };
            break;

        case AuthActions.updateFailed:
            return {
                ...state,
                isLoading: false,
                updateError: true
            };
            break;

        case AuthActions.clearUpdateState:
            return {
                ...state,
                isLoading: false,
                updateError: false
            };
            break;

        default:
            return state;
    }
}
export default authReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/authreducer.js